<template>
    <section class="business">
      <div class="business__content container">
        <div class="column-1 --fade-in-left --delay-1" data-vertical-ivp-class="--animate">
          <h1 class="business__title">
            Growing Our Core Business, Expanding Into Synergistic Markets 
          </h1>
          <img class="image-mobile" src="../assets/business/core-business-mobile.jpg" alt="Image of a rocket">
          <p class="business__description">
            Consumers are buying extended warranties on everything from electronics 
            to consumer goods and more, and the competition to provide this protection 
            is heating up. We are a veteran player in this space, currently offering 
            extended warranty protection through over 1000 retailers.
          </p>
          <p class="business__description">
              While our core business lies in extended warranties, 
              our subsidiaries include reinsurance and an exciting e-commerce business. 
          </p>
          <p class="business__description">
              Our expansion into e-commerce, through our subsidiary ONBLi, Inc., 
              is something we believe could drastically improve people’s online shopping 
              experience through streamlined product offerings and other unique solutions.
          </p>
          <div class="business__button">
            <a  class="button-outlined --text-dark"
            href="https://mhhc.app.dealmaker.tech/invitations/c9a88252-39be-4be8-a114-1718712d60b7/view"
            target="_blank">
            <div class="text">INVEST NOW</div>
            <div class="line -right"></div>
            <div class="line -top"></div>
            <div class="line -left"></div>
            <div class="line -bottom"></div>
          </a>
        </div>
      </div>
      <div class="column-2 --fade-in-right" data-vertical-ivp-class="--animate">
        <img class="image-desktop" src="../assets/business/core-business.jpg" alt="Image of a rocket">
        <div class="business__quote">
          <p>
          “The growth of our core  businesses along with the 
          buildout of additional subsidiaries will  continue to 
          drive shareholder  value for years to come.”
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
  export default {
    name: 'business',
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/business.scss";
  </style>